/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type TopicItem = typeof TopicItem[keyof typeof TopicItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopicItem = {
  accountants: 'accountants',
  accounting: 'accounting',
  'acid-rain': 'acid-rain',
  'acreage-allotments': 'acreage-allotments',
  'actuaries-joint-board-enrollment': 'actuaries-joint-board-enrollment',
  adhesives: 'adhesives',
  'administration-office-executive-office-president': 'administration-office-executive-office-president',
  'administrative-practice-procedure': 'administrative-practice-procedure',
  'adoption-foster-care': 'adoption-foster-care',
  'adult-education': 'adult-education',
  advertising: 'advertising',
  'advisory-committees': 'advisory-committees',
  afghanistan: 'afghanistan',
  'african-development-bank': 'african-development-bank',
  'african-development-foundation': 'african-development-foundation',
  aged: 'aged',
  'agency-international-development': 'agency-international-development',
  'agricultural-commodities': 'agricultural-commodities',
  'agricultural-marketing-service': 'agricultural-marketing-service',
  'agricultural-research': 'agricultural-research',
  'agricultural-research-service': 'agricultural-research-service',
  agriculture: 'agriculture',
  'agriculture-department': 'agriculture-department',
  'aid-families-with-dependent-children': 'aid-families-with-dependent-children',
  'air-carriers': 'air-carriers',
  'air-force-department': 'air-force-department',
  'air-pollution-control': 'air-pollution-control',
  'air-rates-fares': 'air-rates-fares',
  'air-taxis': 'air-taxis',
  'air-traffic-control': 'air-traffic-control',
  'air-traffic-controllers': 'air-traffic-controllers',
  'air-transportation': 'air-transportation',
  'air-transportation-stabilization-board': 'air-transportation-stabilization-board',
  aircraft: 'aircraft',
  airmen: 'airmen',
  airports: 'airports',
  airspace: 'airspace',
  alaska: 'alaska',
  'alcohol-abuse': 'alcohol-abuse',
  'alcohol-alcoholic-beverages': 'alcohol-alcoholic-beverages',
  'alcohol-tobacco-tax-trade-bureau': 'alcohol-tobacco-tax-trade-bureau',
  'alcohol-tobacco-firearms-explosives-bureau': 'alcohol-tobacco-firearms-explosives-bureau',
  alcoholism: 'alcoholism',
  'alien-property': 'alien-property',
  aliens: 'aliens',
  alimony: 'alimony',
  almonds: 'almonds',
  aluminum: 'aluminum',
  'american-battle-monuments-commission': 'american-battle-monuments-commission',
  'american-samoa': 'american-samoa',
  'ammonium-sulfate-plants': 'ammonium-sulfate-plants',
  'anchorage-grounds': 'anchorage-grounds',
  'animal-plant-health-inspection-service': 'animal-plant-health-inspection-service',
  'animal-biologics': 'animal-biologics',
  'animal-diseases': 'animal-diseases',
  'animal-drugs': 'animal-drugs',
  'animal-feeds': 'animal-feeds',
  'animal-foods': 'animal-foods',
  'animal-welfare': 'animal-welfare',
  animals: 'animals',
  antarctica: 'antarctica',
  antidumping: 'antidumping',
  antitrust: 'antitrust',
  appalachia: 'appalachia',
  'appalachian-regional-commission': 'appalachian-regional-commission',
  apples: 'apples',
  apricots: 'apricots',
  'aquatic-plant-control': 'aquatic-plant-control',
  'architectural-transportation-barriers-compliance-board': 'architectural-transportation-barriers-compliance-board',
  'archives-records': 'archives-records',
  'arctic-research-commission': 'arctic-research-commission',
  'armed-forces': 'armed-forces',
  'armed-forces-reserves': 'armed-forces-reserves',
  'armed-forces-retirement-home': 'armed-forces-retirement-home',
  'arms-munitions': 'arms-munitions',
  'army-department': 'army-department',
  arsenic: 'arsenic',
  arson: 'arson',
  'arts-crafts': 'arts-crafts',
  asbestos: 'asbestos',
  'asian-development-bank': 'asian-development-bank',
  australia: 'australia',
  'authority-delegations-government-agencies': 'authority-delegations-government-agencies',
  'aviation-safety': 'aviation-safety',
  avocados: 'avocados',
  'bakery-products': 'bakery-products',
  'bank-deposit-insurance': 'bank-deposit-insurance',
  bankruptcy: 'bankruptcy',
  'banks-banking': 'banks-banking',
  barley: 'barley',
  batteries: 'batteries',
  beans: 'beans',
  beer: 'beer',
  bees: 'bees',
  'benefits-review-board-labor-department': 'benefits-review-board-labor-department',
  benzene: 'benzene',
  beryllium: 'beryllium',
  beverages: 'beverages',
  bicycles: 'bicycles',
  'bilingual-education': 'bilingual-education',
  biologics: 'biologics',
  bison: 'bison',
  'black-lung-benefits': 'black-lung-benefits',
  blind: 'blind',
  'blind-or-severely-disabled-committee-purchase-from-people-who-are': 'blind-or-severely-disabled-committee-purchase-from-people-who-are',
  'blocking-assets': 'blocking-assets',
  blood: 'blood',
  'blood-diseases': 'blood-diseases',
  blueberries: 'blueberries',
  bonds: 'bonds',
  'bottled-water': 'bottled-water',
  boycotts: 'boycotts',
  bridges: 'bridges',
  broadband: 'broadband',
  'broadcasting-board-governors': 'broadcasting-board-governors',
  brokers: 'brokers',
  'buildings-facilities': 'buildings-facilities',
  'bunk-beds': 'bunk-beds',
  burma: 'burma',
  buses: 'buses',
  'business-industry': 'business-industry',
  'cable-television': 'cable-television',
  'cacao-products': 'cacao-products',
  cambodia: 'cambodia',
  'campaign-funds': 'campaign-funds',
  canada: 'canada',
  cancer: 'cancer',
  'carbon-dioxide': 'carbon-dioxide',
  'carbon-industry': 'carbon-industry',
  'carbon-monoxide': 'carbon-monoxide',
  'cargo-vessels': 'cargo-vessels',
  'caribbean-basin-initiative': 'caribbean-basin-initiative',
  'carpets-rugs': 'carpets-rugs',
  carpools: 'carpools',
  cattle: 'cattle',
  'cement-industry': 'cement-industry',
  cemeteries: 'cemeteries',
  'census-bureau': 'census-bureau',
  'census-data': 'census-data',
  'centers-medicare-medicaid-services': 'centers-medicare-medicaid-services',
  'central-intelligence-agency': 'central-intelligence-agency',
  'cereals-food': 'cereals-food',
  cervids: 'cervids',
  chaplains: 'chaplains',
  'charitable-contributions': 'charitable-contributions',
  'charter-flights': 'charter-flights',
  cheese: 'cheese',
  'chemical-safety-hazard-investigation-board': 'chemical-safety-hazard-investigation-board',
  chemicals: 'chemicals',
  cherries: 'cherries',
  'child-labor': 'child-labor',
  'child-support': 'child-support',
  'child-support-enforcement-office': 'child-support-enforcement-office',
  'child-welfare': 'child-welfare',
  china: 'china',
  'cigarette-lighters': 'cigarette-lighters',
  'cigars-cigarettes': 'cigars-cigarettes',
  'citizenship-naturalization': 'citizenship-naturalization',
  'citrus-fruits': 'citrus-fruits',
  'civil-defense': 'civil-defense',
  'civil-disorders': 'civil-disorders',
  'civil-rights': 'civil-rights',
  'civil-rights-commission': 'civil-rights-commission',
  claims: 'claims',
  'classified-information': 'classified-information',
  clemency: 'clemency',
  clothing: 'clothing',
  coal: 'coal',
  'coast-guard': 'coast-guard',
  'coastal-zone': 'coastal-zone',
  'code-federal-regulations': 'code-federal-regulations',
  coffee: 'coffee',
  'coil-coating-industry': 'coil-coating-industry',
  'colleges-universities': 'colleges-universities',
  'color-additives': 'color-additives',
  'commerce-department': 'commerce-department',
  'commodity-credit-corporation': 'commodity-credit-corporation',
  'commodity-futures': 'commodity-futures',
  'commodity-futures-trading-commission': 'commodity-futures-trading-commission',
  'common-carriers': 'common-carriers',
  'communicable-diseases': 'communicable-diseases',
  communications: 'communications',
  'communications-common-carriers': 'communications-common-carriers',
  'communications-equipment': 'communications-equipment',
  'community-action-programs': 'community-action-programs',
  'community-development': 'community-development',
  'community-development-block-grants': 'community-development-block-grants',
  'community-development-financial-institutions-fund': 'community-development-financial-institutions-fund',
  'community-services-office': 'community-services-office',
  'comptroller-currency': 'comptroller-currency',
  'computer-technology': 'computer-technology',
  concessions: 'concessions',
  condominiums: 'condominiums',
  'conduct-standards': 'conduct-standards',
  'confidential-business-information': 'confidential-business-information',
  'conflict-interests': 'conflict-interests',
  'conscientious-objectors': 'conscientious-objectors',
  'construction-industry': 'construction-industry',
  'construction-industry-collective-bargaining-commission': 'construction-industry-collective-bargaining-commission',
  'consumer-product-safety-commission': 'consumer-product-safety-commission',
  'consumer-protection': 'consumer-protection',
  'continental-shelf': 'continental-shelf',
  'cooperative-state-research-education-extension-service': 'cooperative-state-research-education-extension-service',
  cooperatives: 'cooperatives',
  copper: 'copper',
  copyright: 'copyright',
  'copyright-office-library-congress': 'copyright-office-library-congress',
  'copyright-royalty-board': 'copyright-royalty-board',
  corn: 'corn',
  'corporation-national-community-service': 'corporation-national-community-service',
  cosmetics: 'cosmetics',
  board: 'board',
  cotton: 'cotton',
  cottonseeds: 'cottonseeds',
  counterfeiting: 'counterfeiting',
  'countervailing-duties': 'countervailing-duties',
  'court-services-offender-supervision-agency-district-columbia': 'court-services-offender-supervision-agency-district-columbia',
  courts: 'courts',
  cranberries: 'cranberries',
  cream: 'cream',
  credit: 'credit',
  'credit-unions': 'credit-unions',
  'cribs-bassinets': 'cribs-bassinets',
  crime: 'crime',
  'crop-insurance': 'crop-insurance',
  cuba: 'cuba',
  'cultural-exchange-programs': 'cultural-exchange-programs',
  currency: 'currency',
  'customs-border-protection-bureau': 'customs-border-protection-bureau',
  'customs-duties-inspection': 'customs-duties-inspection',
  'dairy-products': 'dairy-products',
  dams: 'dams',
  dates: 'dates',
  'day-care': 'day-care',
  'decorations-medals-awards': 'decorations-medals-awards',
  'defense-communications': 'defense-communications',
  'defense-department': 'defense-department',
  'defense-logistics-agency': 'defense-logistics-agency',
  'defense-nuclear-facilities-safety-board': 'defense-nuclear-facilities-safety-board',
  'delaware-river-basin-commission': 'delaware-river-basin-commission',
  denmark: 'denmark',
  'dental-health': 'dental-health',
  diamonds: 'diamonds',
  'dibenzo-para-dioxins-dibenzofurans': 'dibenzo-para-dioxins-dibenzofurans',
  'dietary-foods': 'dietary-foods',
  'disability-benefits': 'disability-benefits',
  'disaster-assistance': 'disaster-assistance',
  'district-columbia': 'district-columbia',
  diving: 'diving',
  'domestic-violence': 'domestic-violence',
  'drug-abuse': 'drug-abuse',
  'drug-enforcement-administration': 'drug-enforcement-administration',
  'drug-testing': 'drug-testing',
  'drug-traffic-control': 'drug-traffic-control',
  drugs: 'drugs',
  'dry-cleaners': 'dry-cleaners',
  'east-west-foreign-trade-board': 'east-west-foreign-trade-board',
  'economic-analysis-bureau': 'economic-analysis-bureau',
  'economic-development-administration': 'economic-development-administration',
  'economic-statistics': 'economic-statistics',
  ecuador: 'ecuador',
  education: 'education',
  'education-department': 'education-department',
  'education-disadvantaged': 'education-disadvantaged',
  'education-individuals-with-disabilities': 'education-individuals-with-disabilities',
  'educational-facilities': 'educational-facilities',
  'educational-research': 'educational-research',
  'educational-study-programs': 'educational-study-programs',
  'eggs-egg-products': 'eggs-egg-products',
  elections: 'elections',
  'electric-power': 'electric-power',
  'electric-power-plants': 'electric-power-plants',
  'electric-power-rates': 'electric-power-rates',
  'electric-utilities': 'electric-utilities',
  'electronic-funds-transfers': 'electronic-funds-transfers',
  'electronic-products': 'electronic-products',
  electroplating: 'electroplating',
  'elementary-secondary-education': 'elementary-secondary-education',
  'emergency-medical-services': 'emergency-medical-services',
  'emergency-oil-gas-guaranteed-loan-board': 'emergency-oil-gas-guaranteed-loan-board',
  'emergency-powers': 'emergency-powers',
  'emergency-steel-guarantee-loan-board': 'emergency-steel-guarantee-loan-board',
  'employee-benefit-plans': 'employee-benefit-plans',
  'employee-benefits-security-administration': 'employee-benefits-security-administration',
  'employees-compensation-appeals-board': 'employees-compensation-appeals-board',
  employment: 'employment',
  'employment-training-administration': 'employment-training-administration',
  'employment-policy-national-commission': 'employment-policy-national-commission',
  'employment-standards-administration': 'employment-standards-administration',
  'employment-taxes': 'employment-taxes',
  'endangered-threatened-species': 'endangered-threatened-species',
  'endangered-species-committee': 'endangered-species-committee',
  energy: 'energy',
  'energy-conservation': 'energy-conservation',
  'energy-department': 'energy-department',
  engineers: 'engineers',
  'engineers-corps': 'engineers-corps',
  'engraving-printing-bureau': 'engraving-printing-bureau',
  'environmental-impact-statements': 'environmental-impact-statements',
  'environmental-protection': 'environmental-protection',
  'environmental-protection-agency': 'environmental-protection-agency',
  'environmental-quality-council': 'environmental-quality-council',
  'equal-access-justice': 'equal-access-justice',
  'equal-educational-opportunity': 'equal-educational-opportunity',
  'equal-employment-opportunity': 'equal-employment-opportunity',
  'equal-employment-opportunity-commission': 'equal-employment-opportunity-commission',
  'estate-taxes': 'estate-taxes',
  estates: 'estates',
  ethics: 'ethics',
  ethiopia: 'ethiopia',
  'european-bank-reconstruction-development': 'european-bank-reconstruction-development',
  'excise-taxes': 'excise-taxes',
  'executive-office-president': 'executive-office-president',
  'executive-orders': 'executive-orders',
  explosives: 'explosives',
  'export-import-bank': 'export-import-bank',
  exports: 'exports',
  'fair-housing': 'fair-housing',
  'fairs-expositions': 'fairs-expositions',
  'family-assistance-office': 'family-assistance-office',
  'family-planning': 'family-planning',
  'family-planning-miscellaneous-regulations': 'family-planning-miscellaneous-regulations',
  'farm-credit-administration': 'farm-credit-administration',
  'farm-credit-system-insurance-corporation': 'farm-credit-system-insurance-corporation',
  'farm-service-agency': 'farm-service-agency',
  'federal-aviation-administration': 'federal-aviation-administration',
  'federal-buildings-facilities': 'federal-buildings-facilities',
  'federal-communications-commission': 'federal-communications-commission',
  'federal-contract-compliance-programs-office': 'federal-contract-compliance-programs-office',
  'federal-crop-insurance-corporation': 'federal-crop-insurance-corporation',
  'federal-deposit-insurance-corporation': 'federal-deposit-insurance-corporation',
  'federal-election-commission': 'federal-election-commission',
  'federal-emergency-management-agency': 'federal-emergency-management-agency',
  'federal-energy-regulatory-commission': 'federal-energy-regulatory-commission',
  'federal-financial-institutions-examination-council': 'federal-financial-institutions-examination-council',
  'federal-financing-bank': 'federal-financing-bank',
  'federal-highway-administration': 'federal-highway-administration',
  'federal-home-loan-banks': 'federal-home-loan-banks',
  'federal-home-loan-mortgage-corporation': 'federal-home-loan-mortgage-corporation',
  'federal-housing-finance-board': 'federal-housing-finance-board',
  'federal-labor-relations-authority': 'federal-labor-relations-authority',
  'federal-law-enforcement-training-center': 'federal-law-enforcement-training-center',
  'federal-maritime-commission': 'federal-maritime-commission',
  'federal-mediation-conciliation-service': 'federal-mediation-conciliation-service',
  'federal-mine-safety-health-review-commission': 'federal-mine-safety-health-review-commission',
  'federal-motor-carrier-safety-administration': 'federal-motor-carrier-safety-administration',
  'federal-national-mortgage-association': 'federal-national-mortgage-association',
  'federal-open-market-committee': 'federal-open-market-committee',
  'federal-prison-industries': 'federal-prison-industries',
  'federal-procurement-policy-office-cost-accounting-standards-board': 'federal-procurement-policy-office-cost-accounting-standards-board',
  'federal-railroad-administration': 'federal-railroad-administration',
  'federal-register': 'federal-register',
  'federal-register-administrative-committee': 'federal-register-administrative-committee',
  'federal-register-office': 'federal-register-office',
  'federal-reserve-system': 'federal-reserve-system',
  'federal-retirement-thrift-investment-board': 'federal-retirement-thrift-investment-board',
  'federal-service-impasses-panel': 'federal-service-impasses-panel',
  'federal-trade-commission': 'federal-trade-commission',
  'federal-transit-administration': 'federal-transit-administration',
  'federally-affected-areas': 'federally-affected-areas',
  'feed-grains': 'feed-grains',
  feedlots: 'feedlots',
  fertilizers: 'fertilizers',
  filberts: 'filberts',
  'fine-arts-commission': 'fine-arts-commission',
  'fire-prevention': 'fire-prevention',
  firefighters: 'firefighters',
  fireworks: 'fireworks',
  'fiscal-service': 'fiscal-service',
  fish: 'fish',
  'fish-wildlife-service': 'fish-wildlife-service',
  fisheries: 'fisheries',
  fishing: 'fishing',
  'fishing-vessels': 'fishing-vessels',
  flags: 'flags',
  'flammable-materials': 'flammable-materials',
  'flood-control': 'flood-control',
  'flood-insurance': 'flood-insurance',
  'flood-plains': 'flood-plains',
  fluoride: 'fluoride',
  'food-additives': 'food-additives',
  'food-drug-administration': 'food-drug-administration',
  'food-nutrition-service': 'food-nutrition-service',
  'food-assistance-programs': 'food-assistance-programs',
  'food-grades-standards': 'food-grades-standards',
  'food-labeling': 'food-labeling',
  'food-packaging': 'food-packaging',
  'food-safety-inspection-service': 'food-safety-inspection-service',
  'food-stamps': 'food-stamps',
  foods: 'foods',
  'foreign-agricultural-service': 'foreign-agricultural-service',
  'foreign-aid': 'foreign-aid',
  'foreign-assets-control-office': 'foreign-assets-control-office',
  'foreign-banking': 'foreign-banking',
  'foreign-claims': 'foreign-claims',
  'foreign-claims-settlement-commission': 'foreign-claims-settlement-commission',
  'foreign-currencies': 'foreign-currencies',
  'foreign-exchange': 'foreign-exchange',
  'foreign-investments-united-states': 'foreign-investments-united-states',
  'foreign-officials': 'foreign-officials',
  'foreign-relations': 'foreign-relations',
  'foreign-service': 'foreign-service',
  'foreign-service-impasse-disputes-panel': 'foreign-service-impasse-disputes-panel',
  'foreign-service-labor-relations-board': 'foreign-service-labor-relations-board',
  'foreign-trade': 'foreign-trade',
  'foreign-trade-zones': 'foreign-trade-zones',
  'foreign-trade-zones-board': 'foreign-trade-zones-board',
  'forest-service': 'forest-service',
  'forests-forest-products': 'forests-forest-products',
  forgery: 'forgery',
  foundations: 'foundations',
  'four-h-club': 'four-h-club',
  france: 'france',
  fraud: 'fraud',
  'freedom-information': 'freedom-information',
  freight: 'freight',
  'freight-forwarders': 'freight-forwarders',
  'frozen-foods': 'frozen-foods',
  'fruit-juices': 'fruit-juices',
  fruits: 'fruits',
  'fuel-additives': 'fuel-additives',
  'fuel-economy': 'fuel-economy',
  'funeral-industry': 'funeral-industry',
  'furniture-industry': 'furniture-industry',
  furs: 'furs',
  gambling: 'gambling',
  gases: 'gases',
  gasohol: 'gasohol',
  gasoline: 'gasoline',
  'general-accountability-office': 'general-accountability-office',
  'general-services-administration': 'general-services-administration',
  'genetic-diseases': 'genetic-diseases',
  'geological-survey': 'geological-survey',
  'geothermal-energy': 'geothermal-energy',
  'gift-taxes': 'gift-taxes',
  'glass-glass-products': 'glass-glass-products',
  goats: 'goats',
  gold: 'gold',
  'government-contracts': 'government-contracts',
  'government-employees': 'government-employees',
  'government-ethics-office': 'government-ethics-office',
  'government-procurement': 'government-procurement',
  'government-property': 'government-property',
  'government-property-management': 'government-property-management',
  'government-publications': 'government-publications',
  'government-securities': 'government-securities',
  'grain-inspection-packers-stockyards-administration': 'grain-inspection-packers-stockyards-administration',
  grains: 'grains',
  'grant-administrations': 'grant-administrations',
  'grant-programs': 'grant-programs',
  'grant-programs-agriculture': 'grant-programs-agriculture',
  'grant-programs-business': 'grant-programs-business',
  'grant-programs-communications': 'grant-programs-communications',
  'grant-programs-education': 'grant-programs-education',
  'grant-programs-energy': 'grant-programs-energy',
  'grant-programs-environmental-protection': 'grant-programs-environmental-protection',
  'grant-programs-foreign-relations': 'grant-programs-foreign-relations',
  'grant-programs-health': 'grant-programs-health',
  'grant-programs-housing-community-development': 'grant-programs-housing-community-development',
  'grant-programs-indians': 'grant-programs-indians',
  'grant-programs-labor': 'grant-programs-labor',
  'grant-programs-law': 'grant-programs-law',
  'grant-programs-national-defense': 'grant-programs-national-defense',
  'grant-programs-natural-resources': 'grant-programs-natural-resources',
  'grant-programs-recreation': 'grant-programs-recreation',
  'grant-programs-science-technology': 'grant-programs-science-technology',
  'grant-programs-social-programs': 'grant-programs-social-programs',
  'grant-programs-transportation': 'grant-programs-transportation',
  'grant-programs-veterans': 'grant-programs-veterans',
  grapefruit: 'grapefruit',
  grapes: 'grapes',
  'graphic-arts-industry': 'graphic-arts-industry',
  'grazing-lands': 'grazing-lands',
  'great-lakes': 'great-lakes',
  guam: 'guam',
  'guantanamo-bay-naval-station-cuba': 'guantanamo-bay-naval-station-cuba',
  haiti: 'haiti',
  harbors: 'harbors',
  'harry-truman-scholarship-foundation': 'harry-truman-scholarship-foundation',
  'hawaiian-natives': 'hawaiian-natives',
  hay: 'hay',
  'hazardous-materials-transportation': 'hazardous-materials-transportation',
  'hazardous-substances': 'hazardous-substances',
  'hazardous-waste': 'hazardous-waste',
  hazelnuts: 'hazelnuts',
  health: 'health',
  'health-human-services-department': 'health-human-services-department',
  'health-care': 'health-care',
  'health-facilities': 'health-facilities',
  'health-insurance': 'health-insurance',
  'health-maintenance-organizations-hmo': 'health-maintenance-organizations-hmo',
  'health-professions': 'health-professions',
  'health-records': 'health-records',
  'health-statistics': 'health-statistics',
  'heart-diseases': 'heart-diseases',
  heaters: 'heaters',
  helium: 'helium',
  'highway-safety': 'highway-safety',
  'highways-roads': 'highways-roads',
  'historic-preservation': 'historic-preservation',
  'historic-preservation-advisory-council': 'historic-preservation-advisory-council',
  'historical-records': 'historical-records',
  'hiv-aids': 'hiv-aids',
  hobbies: 'hobbies',
  hogs: 'hogs',
  'holding-companies': 'holding-companies',
  holidays: 'holidays',
  'home-improvement': 'home-improvement',
  'homeland-security-department': 'homeland-security-department',
  homeless: 'homeless',
  homesteads: 'homesteads',
  homeworkers: 'homeworkers',
  honey: 'honey',
  horses: 'horses',
  'hospice-care': 'hospice-care',
  hospitals: 'hospitals',
  hostages: 'hostages',
  'household-appliances': 'household-appliances',
  housing: 'housing',
  'housing-urban-development-department': 'housing-urban-development-department',
  'housing-standards': 'housing-standards',
  'human-cells-tissue-based-products': 'human-cells-tissue-based-products',
  'human-development-services-office': 'human-development-services-office',
  'human-research-subjects': 'human-research-subjects',
  'humanitarian-aid': 'humanitarian-aid',
  hunting: 'hunting',
  hydrocarbons: 'hydrocarbons',
  'ice-cream': 'ice-cream',
  immigration: 'immigration',
  'immigration-naturalization': 'immigration-naturalization',
  'immigration-review-executive-office': 'immigration-review-executive-office',
  immunization: 'immunization',
  imports: 'imports',
  'income-taxes': 'income-taxes',
  'indemnity-payments': 'indemnity-payments',
  'independent-counsel-office': 'independent-counsel-office',
  'indian-affairs-bureau': 'indian-affairs-bureau',
  'indian-arts-crafts-board': 'indian-arts-crafts-board',
  'indian-health-service': 'indian-health-service',
  indians: 'indians',
  'indians-arts-crafts': 'indians-arts-crafts',
  'indians-business-finance': 'indians-business-finance',
  'indians-claims': 'indians-claims',
  'indians-education': 'indians-education',
  'indians-enrollment': 'indians-enrollment',
  'indians-judgment-funds': 'indians-judgment-funds',
  'indians-lands': 'indians-lands',
  'indians-law': 'indians-law',
  'indians-tribal-government': 'indians-tribal-government',
  'individuals-with-disabilities': 'individuals-with-disabilities',
  'industry-security-bureau': 'industry-security-bureau',
  'information-security-oversight-office': 'information-security-oversight-office',
  'ink-industry': 'ink-industry',
  'inspector-general-office-health-human-services-department': 'inspector-general-office-health-human-services-department',
  insulation: 'insulation',
  insurance: 'insurance',
  'insurance-companies': 'insurance-companies',
  'inter-american-development-bank': 'inter-american-development-bank',
  'inter-american-foundation': 'inter-american-foundation',
  'intergovernmental-relations': 'intergovernmental-relations',
  'interior-department': 'interior-department',
  'intermodal-transportation': 'intermodal-transportation',
  'internal-revenue-service': 'internal-revenue-service',
  'international-bank-reconstruction-development': 'international-bank-reconstruction-development',
  'international-boundaries': 'international-boundaries',
  'international-boundary-water-commission-u-mexico': 'international-boundary-water-commission-u-mexico',
  'international-development-cooperation-agency': 'international-development-cooperation-agency',
  'international-finance-corporation': 'international-finance-corporation',
  'international-investment-office': 'international-investment-office',
  'international-joint-commission-u-canada': 'international-joint-commission-u-canada',
  'international-organizations': 'international-organizations',
  'international-organizations-employees-loyalty-board': 'international-organizations-employees-loyalty-board',
  'international-trade-administration': 'international-trade-administration',
  'international-trade-commission': 'international-trade-commission',
  'inventions-patents': 'inventions-patents',
  investigations: 'investigations',
  'investment-companies': 'investment-companies',
  investments: 'investments',
  iran: 'iran',
  iraq: 'iraq',
  ireland: 'ireland',
  iron: 'iron',
  irrigation: 'irrigation',
  israel: 'israel',
  'james-madison-memorial-fellowship-foundation': 'james-madison-memorial-fellowship-foundation',
  japan: 'japan',
  'japan-united-states-friendship-commission': 'japan-united-states-friendship-commission',
  'job-corps': 'job-corps',
  'john-f-kennedy-center-performing-arts': 'john-f-kennedy-center-performing-arts',
  jukeboxes: 'jukeboxes',
  'justice-department': 'justice-department',
  'juvenile-delinquency': 'juvenile-delinquency',
  'kidney-diseases': 'kidney-diseases',
  'kingman-reef': 'kingman-reef',
  kiwifruit: 'kiwifruit',
  'korea-democratic-peoples-republic': 'korea-democratic-peoples-republic',
  kuwait: 'kuwait',
  labeling: 'labeling',
  labor: 'labor',
  'labor-department': 'labor-department',
  'labor-management-relations': 'labor-management-relations',
  'labor-management-standards-office': 'labor-management-standards-office',
  'labor-unions': 'labor-unions',
  laboratories: 'laboratories',
  'land-management-bureau': 'land-management-bureau',
  'land-sales': 'land-sales',
  lasers: 'lasers',
  law: 'law',
  'law-enforcement': 'law-enforcement',
  'law-enforcement-officers': 'law-enforcement-officers',
  'lawn-darts': 'lawn-darts',
  'lawn-mowers': 'lawn-mowers',
  lawyers: 'lawyers',
  lead: 'lead',
  'lead-poisoning': 'lead-poisoning',
  'leather-leather-products-industry': 'leather-leather-products-industry',
  lebanon: 'lebanon',
  'legal-services': 'legal-services',
  'legal-services-corporation': 'legal-services-corporation',
  'leprosy-hansen-disease': 'leprosy-hansen-disease',
  liberia: 'liberia',
  libraries: 'libraries',
  'libraries-information-science-national-commission': 'libraries-information-science-national-commission',
  'library-congress': 'library-congress',
  libya: 'libya',
  'lie-detector-tests': 'lie-detector-tests',
  'life-insurance': 'life-insurance',
  'lighthouse-service': 'lighthouse-service',
  lime: 'lime',
  limes: 'limes',
  liquors: 'liquors',
  'literary-works': 'literary-works',
  livestock: 'livestock',
  'loan-programs': 'loan-programs',
  'loan-programs-agriculture': 'loan-programs-agriculture',
  'loan-programs-business': 'loan-programs-business',
  'loan-programs-communications': 'loan-programs-communications',
  'loan-programs-education': 'loan-programs-education',
  'loan-programs-energy': 'loan-programs-energy',
  'loan-programs-foreign-relations': 'loan-programs-foreign-relations',
  'loan-programs-health': 'loan-programs-health',
  'loan-programs-housing-community-development': 'loan-programs-housing-community-development',
  'loan-programs-indians': 'loan-programs-indians',
  'loan-programs-national-defense': 'loan-programs-national-defense',
  'loan-programs-natural-resources': 'loan-programs-natural-resources',
  'loan-programs-social-programs': 'loan-programs-social-programs',
  'loan-programs-transportation': 'loan-programs-transportation',
  'loan-programs-veterans': 'loan-programs-veterans',
  lobbying: 'lobbying',
  'local-television-loan-guarantee-board': 'local-television-loan-guarantee-board',
  'longshore-harbor-workers': 'longshore-harbor-workers',
  lotteries: 'lotteries',
  'low-moderate-income-housing': 'low-moderate-income-housing',
  'lung-diseases': 'lung-diseases',
  'management-budget-office': 'management-budget-office',
  mango: 'mango',
  manpower: 'manpower',
  'manpower-training-programs': 'manpower-training-programs',
  'manufactured-homes': 'manufactured-homes',
  margarine: 'margarine',
  marihuana: 'marihuana',
  'marine-mammal-commission': 'marine-mammal-commission',
  'marine-resources': 'marine-resources',
  'marine-safety': 'marine-safety',
  'marital-status-discrimination': 'marital-status-discrimination',
  'maritime-administration': 'maritime-administration',
  'maritime-carriers': 'maritime-carriers',
  'maritime-security': 'maritime-security',
  'marketing-agreements': 'marketing-agreements',
  'marketing-quotas': 'marketing-quotas',
  'mass-transportation': 'mass-transportation',
  matchbooks: 'matchbooks',
  'maternal-child-health': 'maternal-child-health',
  'mattresses-mattress-pads': 'mattresses-mattress-pads',
  'measurement-standards': 'measurement-standards',
  'meat-meat-products': 'meat-meat-products',
  'meat-inspection': 'meat-inspection',
  medicaid: 'medicaid',
  'medical-dental-schools': 'medical-dental-schools',
  'medical-assistance-program': 'medical-assistance-program',
  'medical-devices': 'medical-devices',
  'medical-research': 'medical-research',
  medicare: 'medicare',
  melons: 'melons',
  'memorandums-presidential': 'memorandums-presidential',
  memorials: 'memorials',
  'mental-health-programs': 'mental-health-programs',
  mercury: 'mercury',
  'merit-systems-protection-board': 'merit-systems-protection-board',
  'metallic-nonmetallic-mineral-processing-plants': 'metallic-nonmetallic-mineral-processing-plants',
  metals: 'metals',
  'metalworking-fluids': 'metalworking-fluids',
  methadone: 'methadone',
  methane: 'methane',
  'metric-system': 'metric-system',
  mexico: 'mexico',
  micrographics: 'micrographics',
  'micronesian-status-negotiations-office': 'micronesian-status-negotiations-office',
  'microwave-ovens': 'microwave-ovens',
  'midway-islands': 'midway-islands',
  'migrant-labor': 'migrant-labor',
  'military-academies': 'military-academies',
  'military-air-transportation': 'military-air-transportation',
  'military-law': 'military-law',
  'military-personnel': 'military-personnel',
  milk: 'milk',
  'milk-marketing-orders': 'milk-marketing-orders',
  'millenium-challenge-corporation': 'millenium-challenge-corporation',
  'mine-safety-health': 'mine-safety-health',
  'mine-safety-health-administration': 'mine-safety-health-administration',
  'mineral-resources': 'mineral-resources',
  'mineral-royalties': 'mineral-royalties',
  'minerals-management-service': 'minerals-management-service',
  miners: 'miners',
  mines: 'mines',
  'minimum-wages': 'minimum-wages',
  'minority-business-development-agency': 'minority-business-development-agency',
  'minority-businesses': 'minority-businesses',
  'mississippi-river': 'mississippi-river',
  mohair: 'mohair',
  'money-orders': 'money-orders',
  'monuments-memorials': 'monuments-memorials',
  'morris-k-udall-scholarship-excellence-national-environmental-policy-foundation': 'morris-k-udall-scholarship-excellence-national-environmental-policy-foundation',
  'mortgage-insurance': 'mortgage-insurance',
  mortgages: 'mortgages',
  'motion-pictures': 'motion-pictures',
  'motor-carriers': 'motor-carriers',
  'motor-vehicle-pollution': 'motor-vehicle-pollution',
  'motor-vehicle-safety': 'motor-vehicle-safety',
  'motor-vehicles': 'motor-vehicles',
  'moving-household-goods': 'moving-household-goods',
  'multi-purpose-lighters': 'multi-purpose-lighters',
  museums: 'museums',
  mushrooms: 'mushrooms',
  music: 'music',
  'national-aeronautics-space-administration': 'national-aeronautics-space-administration',
  'national-arboretum': 'national-arboretum',
  'national-archives-records-administration': 'national-archives-records-administration',
  'national-banks': 'national-banks',
  'national-capital-planning-commission': 'national-capital-planning-commission',
  'national-council-disability': 'national-council-disability',
  'national-counterintelligence-center': 'national-counterintelligence-center',
  'national-credit-union-administration': 'national-credit-union-administration',
  'national-crime-prevention-privacy-compact-council': 'national-crime-prevention-privacy-compact-council',
  'national-defense': 'national-defense',
  'national-drug-control-policy-office': 'national-drug-control-policy-office',
  'national-forests': 'national-forests',
  'national-foundation-arts-humanities': 'national-foundation-arts-humanities',
  'national-gallery-art': 'national-gallery-art',
  'national-grasslands': 'national-grasslands',
  'national-highway-traffic-safety-administration': 'national-highway-traffic-safety-administration',
  'national-indian-gaming-commission': 'national-indian-gaming-commission',
  'national-institute-literacy': 'national-institute-literacy',
  'national-institute-standards-technology': 'national-institute-standards-technology',
  'national-intelligence-office-director': 'national-intelligence-office-director',
  'national-labor-relations-board': 'national-labor-relations-board',
  'national-mediation-board': 'national-mediation-board',
  'national-ocean-survey': 'national-ocean-survey',
  'national-oceanic-atmospheric-administration': 'national-oceanic-atmospheric-administration',
  'national-park-service': 'national-park-service',
  'national-parks': 'national-parks',
  'national-railroad-adjustment-board': 'national-railroad-adjustment-board',
  'national-railroad-passenger-corporation-amtrak': 'national-railroad-passenger-corporation-amtrak',
  'national-science-foundation': 'national-science-foundation',
  'national-security-agency-central-security-service': 'national-security-agency-central-security-service',
  'national-security-council': 'national-security-council',
  'national-telecommunications-information-administration': 'national-telecommunications-information-administration',
  'national-trails-system': 'national-trails-system',
  'national-transportation-safety-board': 'national-transportation-safety-board',
  'national-wild-scenic-rivers-system': 'national-wild-scenic-rivers-system',
  'national-zoological-park': 'national-zoological-park',
  'natural-gas': 'natural-gas',
  'natural-resources': 'natural-resources',
  'natural-resources-conservation-service': 'natural-resources-conservation-service',
  'navajo-hopi-indian-relocation-office': 'navajo-hopi-indian-relocation-office',
  'navigation-air': 'navigation-air',
  'navigation-water': 'navigation-water',
  'navy-department': 'navy-department',
  nectarines: 'nectarines',
  'neighborhood-reinvestment-corporation': 'neighborhood-reinvestment-corporation',
  'new-investment': 'new-investment',
  'news-media': 'news-media',
  'newspapers-magazines': 'newspapers-magazines',
  nicaragua: 'nicaragua',
  'nitric-acid-plants': 'nitric-acid-plants',
  'nitrogen-dioxide': 'nitrogen-dioxide',
  'nitrogen-oxides': 'nitrogen-oxides',
  'noise-control': 'noise-control',
  'nonprofit-organizations': 'nonprofit-organizations',
  'northeast-interstate-low-level-radioactive-waste-commission': 'northeast-interstate-low-level-radioactive-waste-commission',
  'northern-mariana-islands': 'northern-mariana-islands',
  'nuclear-energy': 'nuclear-energy',
  'nuclear-materials': 'nuclear-materials',
  'nuclear-power-plants-reactors': 'nuclear-power-plants-reactors',
  'nuclear-regulatory-commission': 'nuclear-regulatory-commission',
  'nuclear-vessels': 'nuclear-vessels',
  'nuclear-waste-technical-review-board': 'nuclear-waste-technical-review-board',
  'nursery-stock': 'nursery-stock',
  'nursing-homes': 'nursing-homes',
  nutrition: 'nutrition',
  nuts: 'nuts',
  oats: 'oats',
  'occupational-safety-health': 'occupational-safety-health',
  'occupational-safety-health-administration': 'occupational-safety-health-administration',
  'occupational-safety-health-review-commission': 'occupational-safety-health-review-commission',
  'oceanographic-research-vessels': 'oceanographic-research-vessels',
  'oil-gas-exploration': 'oil-gas-exploration',
  'oil-gas-reserves': 'oil-gas-reserves',
  'oil-imports': 'oil-imports',
  'oil-pollution': 'oil-pollution',
  'oils-fats': 'oils-fats',
  oilseeds: 'oilseeds',
  'oklahoma-city-national-memorial-trust': 'oklahoma-city-national-memorial-trust',
  'old-age-survivors-disability-insurance': 'old-age-survivors-disability-insurance',
  olives: 'olives',
  onions: 'onions',
  'ophthalmic-goods-services': 'ophthalmic-goods-services',
  oranges: 'oranges',
  'organization-functions-government-agencies': 'organization-functions-government-agencies',
  'over-counter-drugs': 'over-counter-drugs',
  'overseas-private-investment-corporation': 'overseas-private-investment-corporation',
  ozone: 'ozone',
  'pacific-islands-trust-territory': 'pacific-islands-trust-territory',
  'packaging-containers': 'packaging-containers',
  'paint-industry': 'paint-industry',
  'paper-paper-products-industry': 'paper-paper-products-industry',
  parking: 'parking',
  'particulate-matter': 'particulate-matter',
  'passenger-vessels': 'passenger-vessels',
  'passports-visas': 'passports-visas',
  'patent-trademark-office-u': 'patent-trademark-office-u',
  'paving-roofing-materials': 'paving-roofing-materials',
  'peace-corps': 'peace-corps',
  peaches: 'peaches',
  peanuts: 'peanuts',
  pears: 'pears',
  'peer-review-organizations-pro': 'peer-review-organizations-pro',
  penalties: 'penalties',
  'pennsylvania-avenue-development-corporation': 'pennsylvania-avenue-development-corporation',
  'pension-benefit-guaranty-corporation': 'pension-benefit-guaranty-corporation',
  'pension-insurance': 'pension-insurance',
  'personnel-management-office': 'personnel-management-office',
  petroleum: 'petroleum',
  'petroleum-allocation': 'petroleum-allocation',
  'petroleum-price-regulations': 'petroleum-price-regulations',
  pets: 'pets',
  philippines: 'philippines',
  phosphate: 'phosphate',
  'photographic-industry': 'photographic-industry',
  'pipeline-hazardous-materials-safety-administration-transportation-department': 'pipeline-hazardous-materials-safety-administration-transportation-department',
  'pipeline-safety': 'pipeline-safety',
  pipelines: 'pipelines',
  pistachios: 'pistachios',
  'plant-diseases-pests': 'plant-diseases-pests',
  plants: 'plants',
  'plastics-materials-synthetics': 'plastics-materials-synthetics',
  plums: 'plums',
  plutonium: 'plutonium',
  'poison-prevention': 'poison-prevention',
  'political-activities-government-employees': 'political-activities-government-employees',
  'political-affiliation-discrimination': 'political-affiliation-discrimination',
  'political-candidates': 'political-candidates',
  'political-committees-parties': 'political-committees-parties',
  'polychlorinated-biphenyls-pcb': 'polychlorinated-biphenyls-pcb',
  polymers: 'polymers',
  popcorn: 'popcorn',
  'porcelain-enameling-industry': 'porcelain-enameling-industry',
  'postal-rate-commission': 'postal-rate-commission',
  'postal-regulatory-commission': 'postal-regulatory-commission',
  'postal-service': 'postal-service',
  potassium: 'potassium',
  potatoes: 'potatoes',
  'poultry-poultry-products': 'poultry-poultry-products',
  'prescription-drugs': 'prescription-drugs',
  'presidential-documents': 'presidential-documents',
  'presidio-trust': 'presidio-trust',
  'price-controls': 'price-controls',
  'price-support-programs': 'price-support-programs',
  printing: 'printing',
  prisoners: 'prisoners',
  'prisoners-war': 'prisoners-war',
  prisons: 'prisons',
  'prisons-bureau': 'prisons-bureau',
  privacy: 'privacy',
  'private-schools': 'private-schools',
  'probation-parole': 'probation-parole',
  proclamations: 'proclamations',
  prunes: 'prunes',
  'public-assistance-programs': 'public-assistance-programs',
  'public-health': 'public-health',
  'public-health-service': 'public-health-service',
  'public-housing': 'public-housing',
  'public-lands': 'public-lands',
  'public-lands-classification': 'public-lands-classification',
  'public-lands-grants': 'public-lands-grants',
  'public-lands-mineral-resources': 'public-lands-mineral-resources',
  'public-lands-rights-way': 'public-lands-rights-way',
  'public-lands-sale': 'public-lands-sale',
  'public-lands-withdrawal': 'public-lands-withdrawal',
  'public-papers-presidents-united-states': 'public-papers-presidents-united-states',
  'puerto-rico': 'puerto-rico',
  quarantine: 'quarantine',
  'rabbits-rabbit-products': 'rabbits-rabbit-products',
  'radiation-protection': 'radiation-protection',
  radio: 'radio',
  'radioactive-materials': 'radioactive-materials',
  radionuclides: 'radionuclides',
  radon: 'radon',
  'railroad-employees': 'railroad-employees',
  'railroad-retirement': 'railroad-retirement',
  'railroad-retirement-board': 'railroad-retirement-board',
  'railroad-safety': 'railroad-safety',
  'railroad-unemployment-insurance': 'railroad-unemployment-insurance',
  railroads: 'railroads',
  raisins: 'raisins',
  'range-management': 'range-management',
  'real-property-acquisition': 'real-property-acquisition',
  reclamation: 'reclamation',
  'reclamation-bureau': 'reclamation-bureau',
  recordings: 'recordings',
  recycling: 'recycling',
  'red-cross': 'red-cross',
  refrigerators: 'refrigerators',
  'refugee-resettlement-office': 'refugee-resettlement-office',
  refugees: 'refugees',
  'refuse-bins': 'refuse-bins',
  reindeer: 'reindeer',
  'religious-discrimination': 'religious-discrimination',
  'relocation-assistance': 'relocation-assistance',
  'rent-subsidies': 'rent-subsidies',
  'reporting-recordkeeping-requirements': 'reporting-recordkeeping-requirements',
  research: 'research',
  reservoirs: 'reservoirs',
  retirement: 'retirement',
  'revenue-sharing': 'revenue-sharing',
  rice: 'rice',
  'rights-way': 'rights-way',
  rivers: 'rivers',
  'rubber-rubber-products': 'rubber-rubber-products',
  'rural-areas': 'rural-areas',
  'rural-business-cooperative-service': 'rural-business-cooperative-service',
  'rural-housing-service': 'rural-housing-service',
  'rural-telephone-bank': 'rural-telephone-bank',
  'rural-utilities-service': 'rural-utilities-service',
  'russian-federation': 'russian-federation',
  safety: 'safety',
  'saint-lawrence-seaway-development-corporation': 'saint-lawrence-seaway-development-corporation',
  satellites: 'satellites',
  'savings-associations': 'savings-associations',
  'scholarships-fellowships': 'scholarships-fellowships',
  'school-breakfast-lunch-programs': 'school-breakfast-lunch-programs',
  'school-construction': 'school-construction',
  schools: 'schools',
  'science-technology': 'science-technology',
  'science-technology-policy-office': 'science-technology-policy-office',
  'scientific-equipment': 'scientific-equipment',
  scientists: 'scientists',
  seafood: 'seafood',
  'seals-insignia': 'seals-insignia',
  seamen: 'seamen',
  'search-warrants': 'search-warrants',
  seashores: 'seashores',
  'secret-service': 'secret-service',
  securities: 'securities',
  'securities-exchange-commission': 'securities-exchange-commission',
  'security-measures': 'security-measures',
  seeds: 'seeds',
  'seismic-safety': 'seismic-safety',
  'seizures-forfeitures': 'seizures-forfeitures',
  'selective-service-system': 'selective-service-system',
  'semiconductor-chip-products': 'semiconductor-chip-products',
  services: 'services',
  'sewage-disposal': 'sewage-disposal',
  'sex-discrimination': 'sex-discrimination',
  sheep: 'sheep',
  shoes: 'shoes',
  'signs-symbols': 'signs-symbols',
  silk: 'silk',
  silver: 'silver',
  'small-business-administration': 'small-business-administration',
  'small-businesses': 'small-businesses',
  smallpox: 'smallpox',
  'smithsonian-institution': 'smithsonian-institution',
  smoking: 'smoking',
  'soap-detergent-industry': 'soap-detergent-industry',
  'social-security': 'social-security',
  'social-security-administration': 'social-security-administration',
  sodium: 'sodium',
  'soil-conservation': 'soil-conservation',
  'solar-energy': 'solar-energy',
  'solar-energy-energy-conservation-bank': 'solar-energy-energy-conservation-bank',
  sorghum: 'sorghum',
  soybeans: 'soybeans',
  'space-transportation-exploration': 'space-transportation-exploration',
  'spearmint-oil': 'spearmint-oil',
  'special-counsel-office': 'special-counsel-office',
  'specially-designated-nationals': 'specially-designated-nationals',
  'spices-flavorings': 'spices-flavorings',
  'sporting-goods': 'sporting-goods',
  sports: 'sports',
  'spray-cans': 'spray-cans',
  'state-local-governments': 'state-local-governments',
  'state-department': 'state-department',
  statistics: 'statistics',
  steel: 'steel',
  stills: 'stills',
  stocks: 'stocks',
  stockyards: 'stockyards',
  'strategic-critical-materials': 'strategic-critical-materials',
  straw: 'straw',
  'student-aid': 'student-aid',
  'student-loan-marketing-association-sallie-mae': 'student-loan-marketing-association-sallie-mae',
  students: 'students',
  sudan: 'sudan',
  sugar: 'sugar',
  sulfur: 'sulfur',
  'sulfur-oxides': 'sulfur-oxides',
  'sulfuric-acid-plants': 'sulfuric-acid-plants',
  'sunshine-act': 'sunshine-act',
  superfund: 'superfund',
  'supplemental-security-income-ssi': 'supplemental-security-income-ssi',
  'surety-bonds': 'surety-bonds',
  'surface-mining': 'surface-mining',
  'surface-mining-reclamation-appeals-board': 'surface-mining-reclamation-appeals-board',
  'surface-mining-reclamation-enforcement-office': 'surface-mining-reclamation-enforcement-office',
  'surface-transportation-board': 'surface-transportation-board',
  'surplus-government-property': 'surplus-government-property',
  'susquehanna-river-basin-commission': 'susquehanna-river-basin-commission',
  'swimming-pool-slides': 'swimming-pool-slides',
  'swine-flu-immunization-program': 'swine-flu-immunization-program',
  switzerland: 'switzerland',
  tangelos: 'tangelos',
  tangerines: 'tangerines',
  'tax-treaties': 'tax-treaties',
  taxes: 'taxes',
  tea: 'tea',
  teachers: 'teachers',
  'technical-assistance': 'technical-assistance',
  'technology-administration-commerce-department': 'technology-administration-commerce-department',
  telecommunications: 'telecommunications',
  telegraph: 'telegraph',
  telephone: 'telephone',
  television: 'television',
  'tennessee-valley-authority': 'tennessee-valley-authority',
  terrorism: 'terrorism',
  textiles: 'textiles',
  thorium: 'thorium',
  'thrift-supervision-office': 'thrift-supervision-office',
  time: 'time',
  tires: 'tires',
  tobacco: 'tobacco',
  tomatoes: 'tomatoes',
  toys: 'toys',
  'trade-adjustment-assistance': 'trade-adjustment-assistance',
  'trade-agreements': 'trade-agreements',
  'trade-names': 'trade-names',
  'trade-practices': 'trade-practices',
  'trade-representative-office-united-states': 'trade-representative-office-united-states',
  trademarks: 'trademarks',
  'traffic-regulations': 'traffic-regulations',
  transportation: 'transportation',
  'transportation-department': 'transportation-department',
  'transportation-office-agriculture-department': 'transportation-office-agriculture-department',
  'transportation-security-administration': 'transportation-security-administration',
  'transportation-statistics-bureau': 'transportation-statistics-bureau',
  travel: 'travel',
  'travel-transportation-expenses': 'travel-transportation-expenses',
  'travel-restrictions': 'travel-restrictions',
  'treasury-department': 'treasury-department',
  treaties: 'treaties',
  trees: 'trees',
  'trusts-trustees': 'trusts-trustees',
  'truth-lending': 'truth-lending',
  'truth-savings': 'truth-savings',
  tuberculosis: 'tuberculosis',
  'underground-mining': 'underground-mining',
  'unemployment-compensation': 'unemployment-compensation',
  'uniform-system-accounts': 'uniform-system-accounts',
  'united-service-organizations-uso': 'united-service-organizations-uso',
  'united-states-government-manual': 'united-states-government-manual',
  'united-states-institute-peace': 'united-states-institute-peace',
  'united-states-investments-abroad': 'united-states-investments-abroad',
  'upper-mississippi-river-basin-commission': 'upper-mississippi-river-basin-commission',
  uranium: 'uranium',
  'urban-areas': 'urban-areas',
  urethane: 'urethane',
  'utah-reclamation-mitigation-conservation-commission': 'utah-reclamation-mitigation-conservation-commission',
  utilities: 'utilities',
  'vegetable-juices': 'vegetable-juices',
  vegetables: 'vegetables',
  'venereal-diseases': 'venereal-diseases',
  vessels: 'vessels',
  veterans: 'veterans',
  'veterans-affairs-department': 'veterans-affairs-department',
  'veterans-employment-training-service-office-assistant-secretary-labor-department': 'veterans-employment-training-service-office-assistant-secretary-labor-department',
  veterinarians: 'veterinarians',
  'vice-president-u-office': 'vice-president-u-office',
  'victim-compensation': 'victim-compensation',
  vietnam: 'vietnam',
  vinegar: 'vinegar',
  vinyl: 'vinyl',
  'vinyl-chloride': 'vinyl-chloride',
  'virgin-islands': 'virgin-islands',
  'vocational-education': 'vocational-education',
  'vocational-rehabilitation': 'vocational-rehabilitation',
  'volatile-organic-compounds': 'volatile-organic-compounds',
  'voluntary-standards': 'voluntary-standards',
  volunteers: 'volunteers',
  'voting-rights': 'voting-rights',
  'wage-hour-division': 'wage-hour-division',
  wages: 'wages',
  'wake-island': 'wake-island',
  walnuts: 'walnuts',
  'war-claims': 'war-claims',
  'war-risk-insurance': 'war-risk-insurance',
  warehouses: 'warehouses',
  'waste-treatment-disposal': 'waste-treatment-disposal',
  'watches-jewelry': 'watches-jewelry',
  'water-bank-program': 'water-bank-program',
  'water-pollution-control': 'water-pollution-control',
  'water-resources': 'water-resources',
  'water-resources-council': 'water-resources-council',
  'water-supply': 'water-supply',
  watermelons: 'watermelons',
  watersheds: 'watersheds',
  waterways: 'waterways',
  weather: 'weather',
  'weekly-compilation-presidential-documents': 'weekly-compilation-presidential-documents',
  'western-balkans': 'western-balkans',
  'marine-mammals': 'marine-mammals',
  wheat: 'wheat',
  whistleblowing: 'whistleblowing',
  'white-house-fellowships-president-commission': 'white-house-fellowships-president-commission',
  'wilderness-areas': 'wilderness-areas',
  wildlife: 'wildlife',
  'wildlife-refuges': 'wildlife-refuges',
  wine: 'wine',
  'wiretapping-electronic-surveillance': 'wiretapping-electronic-surveillance',
  women: 'women',
  'woodrow-wilson-international-center-scholars': 'woodrow-wilson-international-center-scholars',
  wool: 'wool',
  'work-incentive-programs-win': 'work-incentive-programs-win',
  'workers-compensation': 'workers-compensation',
  'workers-compensation-programs-office': 'workers-compensation-programs-office',
  'x-rays': 'x-rays',
  yogurt: 'yogurt',
  youth: 'youth',
  yugoslavia: 'yugoslavia',
  zinc: 'zinc',
  zoning: 'zoning',
  'advance-care-planning': 'advance-care-planning',
  antibiotics: 'antibiotics',
  'assisted-suicide': 'assisted-suicide',
  'biobased-products': 'biobased-products',
  'community-facilities': 'community-facilities',
  'compilation-presidential-documents': 'compilation-presidential-documents',
  'conflicts-interests': 'conflicts-interests',
  'critical-infrastructure': 'critical-infrastructure',
  crowdfunding: 'crowdfunding',
  diseases: 'diseases',
  'electronic-filing': 'electronic-filing',
  'emergency-preparedness': 'emergency-preparedness',
  fees: 'fees',
  'foreign-investments-u': 'foreign-investments-u',
  gemstones: 'gemstones',
  ginseng: 'ginseng',
  'government-transparency': 'government-transparency',
  'government-sponsored-enterprises': 'government-sponsored-enterprises',
  'grants-administration': 'grants-administration',
  'greenhouse-gases': 'greenhouse-gases',
  'human-remains': 'human-remains',
  'incorporation-reference': 'incorporation-reference',
  'industrial-facilities': 'industrial-facilities',
  'infants-children': 'infants-children',
  information: 'information',
  'international-financial-institutions': 'international-financial-institutions',
  internet: 'internet',
  'licensing-registration': 'licensing-registration',
  marijuana: 'marijuana',
  'organically-produced-products': 'organically-produced-products',
  'paleontological-resources': 'paleontological-resources',
  pensions: 'pensions',
  'personally-identifiable-information': 'personally-identifiable-information',
  'pesticides-pests': 'pesticides-pests',
  'public-papers-presidents-u': 'public-papers-presidents-u',
  'qualified-financial-contracts': 'qualified-financial-contracts',
  'recreation-recreation-areas': 'recreation-recreation-areas',
  'renewable-energy': 'renewable-energy',
  suicide: 'suicide',
  'supplemental-nutrition-assistance-program': 'supplemental-nutrition-assistance-program',
  'surplus-agricultural-commodities': 'surplus-agricultural-commodities',
  swaps: 'swaps',
  swine: 'swine',
  'towing-vessels': 'towing-vessels',
  'traffic-regulation': 'traffic-regulation',
  'u-government-manual': 'u-government-manual',
  'u-investments-abroad': 'u-investments-abroad',
  'urban-renewal': 'urban-renewal',
  waivers: 'waivers',
  warranties: 'warranties',
  'youth-organizations': 'youth-organizations',
} as const;
